import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@bpinternal/ui-kit-next'
import { ArrowUpDown, Clock, Calendar, Type } from 'lucide-react'
import { SortType } from '../hooks/useBotSort'

type SortDropdownProps = {
  sortType: SortType
  onSortTypeChange: (sortType: SortType) => void
}

export const SortDropdown = ({ sortType, onSortTypeChange }: SortDropdownProps) => {
  const sortOptions = [
    {
      type: 'lastViewed' as const,
      label: 'Last viewed',
      icon: Clock,
    },
    {
      type: 'alphabetical' as const,
      label: 'Alphabetical',
      icon: Type,
    },
    {
      type: 'dateCreated' as const,
      label: 'Date created',
      icon: Calendar,
    },
  ]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="h-9 w-9">
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {sortOptions.map((option) => {
          const Icon = option.icon
          const isSelected = option.type === sortType
          return (
            <DropdownMenuItem
              key={option.type}
              onClick={() => onSortTypeChange(option.type)}
              className={isSelected ? 'bg-accent' : ''}
            >
              <Icon className="mr-2 h-4 w-4" />
              {option.label}
              {isSelected && <span className="ml-auto text-xs">✓</span>}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
